import { FormattedDate } from 'react-intl';

import { useAlgoTileId } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTradeIdFromAlgoTile } from '@/store/orders/algoOrders/selectors.ts';
import { selectOrderEntryByIdFromBlotter } from '@/store/orders/fixing/selectors.ts';

const AlgoEditingStartDate = () => {
  const tileId = useAlgoTileId();
  const tradeId = useAppSelector((state) => selectTradeIdFromAlgoTile(state, tileId));

  const orderFromBlotter = useAppSelector((state) =>
    tradeId ? selectOrderEntryByIdFromBlotter(state, tradeId) : undefined,
  );
  return (
    orderFromBlotter?.startTime && (
      <OrderRow labelId="order.fields.startDate.label">
        <FormattedDate
          value={orderFromBlotter?.startTime}
          day="2-digit"
          month="short"
          year="numeric"
          hour="2-digit"
          minute="numeric"
          hour12
        />
      </OrderRow>
    )
  );
};

export default AlgoEditingStartDate;
